import axios, {AxiosResponse} from "axios";
import {SpringPagedResult} from "@/service/PagedResult";
import {OrderChange} from "@/model/OrderHistory";

class OrderHistoryService {
    /**
     * Gets the changes of an order, newest first. The server ignores any sort parameter.
     */
    getOrderChanges(orderUuid: string, page: number, size: number): Promise<AxiosResponse<SpringPagedResult<OrderChange>>> {
        return axios.get(`/v2/orders/${orderUuid}/changes`, {params: {page, size}});
    }
}

export default new OrderHistoryService();
